import { graphql } from 'gql';

export const removeCatalogOtherCostVariableGql = graphql(`
    mutation removeCatalogOtherCostVariable($otherCostVariableId: Long!) {
        removeCatalogOtherCostVariable(otherCostVariableId: $otherCostVariableId) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);
